import createStaticResourceAPI from "@/helpers/rtk_static_resource_factory";

const baseURL = process.env.REACT_APP_FMS_API + '/transactions/obligations';

export const obligationsAPI = createStaticResourceAPI({
  baseURL: baseURL,
  resource: "Obligations",
  tagTypes: ["Obligations"],
  idKey: "obligationId",
  lookupMap: ({ obligationId, referenceNo }) => ({
    value: obligationId,
    label: referenceNo
  }),
  customQuery: (query, { idKey, resource, baseURL }) => ({
    getListObligationsForViewers: query(`${baseURL}/listForViewer`, {
      serializeQueryArgs: ({ endpointName }) => endpointName,
      providesTags: (result) => {
        if (!result?.success || !Array.isArray(result.returnData)) {
          return [{ type: resource, id: "LIST" }];
        }

        return [
          ...result.returnData.map((item) => ({
            type: resource,
            id: item[idKey],
          })),
          { type: resource, id: "LIST" },
        ];
      }
    }),
  }),
  customMutations: (mutation, mutationOptions) => ({
    submitObligations: mutation(`${baseURL}/submit`, mutationOptions("save")),
    returnObligations: mutation(`${baseURL}/return`, mutationOptions("save")),
    approveObligations: mutation(`${baseURL}/approve`, mutationOptions("save")),
    rejectObligations: mutation(`${baseURL}/reject`, mutationOptions("save")),
    cancelObligations: mutation(`${baseURL}/cancel`, mutationOptions("save")),
  }),
});

export const {
  useGetObligationsQuery,
  useGetListObligationsForViewersQuery,
  useExportObligationsMutation,
  useFindObligationsQuery,
  useLookUpObligationsMutation,
  useSaveObligationsMutation,
  useSubmitObligationsMutation,
  useReturnObligationsMutation,
  useApproveObligationsMutation,
  useRejectObligationsMutation,
  useCancelObligationsMutation,
  useDeleteObligationsMutation
} = obligationsAPI;
